// extracted by mini-css-extract-plugin
module.exports = {"noShrink":"styles_noShrink__1Htcj","instructions":"styles_instructions__RroC3","submit":"styles_submit__1IlMg"};